import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=c42ab78c&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=c42ab78c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42ab78c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c42ab78c')) {
      api.createRecord('c42ab78c', component.options)
    } else {
      api.reload('c42ab78c', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=c42ab78c&scoped=true&", function () {
      api.rerender('c42ab78c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bI27SHJhlNcx/JS/comp/CookieBox.vue"
export default component.exports